import type { ComponentProps, ReactNode } from "react";
import { Check, X } from "@repo/ui";
import { cn } from "@repo/utils";

type ControlType = "confirm" | "cancel";

type Props = {
  controlType: ControlType;
} & ComponentProps<"button">;

export const WorkflowsInputControl = ({ controlType, ...props }: Props) => {
  const iconMap: Record<ControlType, ReactNode> = {
    confirm: <Check strokeWidth="2px" size="12px" />,
    cancel: <X strokeWidth="2px" size="12px" />,
  };
  return (
    <button
      {...props}
      className={cn(
        "flex h-5 w-5 cursor-pointer items-center justify-center rounded-full text-white",
        "disabled:cursor-not-allowed disabled:opacity-50",
        { "bg-blue-700": controlType === "confirm" },
        { "bg-red-600": controlType === "cancel" }
      )}
    >
      {iconMap[controlType]}
    </button>
  );
};
